import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { WarehouseMaterialGridObject, WarehouseMaterialObject } from '@libs/types/src/services/object-type/service/social-service/warehouse-material.object';
import { WarehouseMaterialOperationCreateInput } from '@libs/types/src/services/input-type/services/social-service/warehouse-material-operation.create-input';
import { WarehouseMaterialOperationPatchInput } from '@libs/types/src/services/input-type/services/social-service/warehouse-material-operation.patch-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { filterFrag } from './types/filter.types';

@Injectable({ providedIn: 'root' })
export class WarehouseMaterialOperationGqlService extends GqlServiceV2 {

    public getWarehouseMaterialOperations(input: GridInput | null, frag: string) {
        return this.query<WarehouseMaterialGridObject>(
            `
                query($input: GridInput!) {
                    warehouseMaterialOperation {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createWarehouseMaterialOperation(input: WarehouseMaterialOperationCreateInput, frag: string) {
        return this.mutate<WarehouseMaterialObject>(
            `
                mutation($input: WarehouseMaterialOperationCreateInput!) {
                    warehouseMaterialOperation {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchWarehouseMaterialOperation(input: WarehouseMaterialOperationPatchInput, frag: string) {
        return this.mutate<WarehouseMaterialObject>(
            `
                mutation($input: WarehouseMaterialOperationPatchInput!) {
                    warehouseMaterialOperation {
                        patch(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteWarehouseMaterialOperation(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    warehouseMaterialOperation {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
